module.exports = __webpack_public_path__ + "static/media/shareit-dark-green.22b67d0e.svg";